const getISOFormattedDate = (date) => date.toISOString();

export default getISOFormattedDate;
